import { render, staticRenderFns } from "./SIdentify.vue?vue&type=template&id=5eb14e28&"
import script from "./SIdentify.vue?vue&type=script&lang=js&"
export * from "./SIdentify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports